import { ElementRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MatPaginator, MatSort } from '@angular/material';
import { ObservableMedia } from '@angular/flex-layout';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { debounceTime } from 'rxjs/operators/debounceTime';
import { distinctUntilChanged } from 'rxjs/operators/distinctUntilChanged';
import { first } from 'rxjs/operators/first';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { DataTableSource } from '../../../classes/DataTableSource/datatablesource';
import { ApplicationService } from '../../application/application.service';
import { SplashService } from '../../splash/splash.service';
import { UserService } from '../../user/user.service';
var StudentSearchDialogComponent = /** @class */ (function () {
    function StudentSearchDialogComponent(appService, fb, dialogRef, data, mediaChange, splashService, userService) {
        this.appService = appService;
        this.fb = fb;
        this.dialogRef = dialogRef;
        this.mediaChange = mediaChange;
        this.splashService = splashService;
        this.userService = userService;
        this._subrelease = new Subject();
        this.AllHeaders = ['LastName', 'FirstName', 'StudentID', 'School', 'Grade', 'Actions'];
        this.canceltext = data.CancelText || 'Cancel';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'Select';
        this.title = data.TitleText || 'User Search';
        this.ReportInfo = data.ReportInfo;
        this.AvailableSchoolGrades = data.AvailableSchoolGrades || ['All', '06', '07', '08', '09', '10', '11', '12'];
    }
    StudentSearchDialogComponent.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
    };
    StudentSearchDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        var self = this;
        self.SearchReady = false;
        self.ShowSearch = true;
        self.LastSizeCode = self.mediaChange.isActive('xs')
            ? 'xs'
            : self.mediaChange.isActive('sm')
                ? 'sm'
                : self.mediaChange.isActive('md')
                    ? 'md'
                    : self.mediaChange.isActive('lg')
                        ? 'lg'
                        : 'xl';
        self.SmallDisplay = self.LastSizeCode === 'xs' || self.LastSizeCode === 'sm';
        self.mediaChange
            .asObservable()
            .pipe(takeUntil(self._subrelease))
            .subscribe(function (media) {
            self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
            self.LastSizeCode = media.mqAlias;
            self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
            self.VisibleColumns =
                !self.StudentList || !self.StudentList.length
                    ? ['NoData']
                    : self.SmallDisplay
                        ? ['SmallDisplay']
                        : self.VisibleHeaders.slice();
        });
        fromEvent(self.filter.nativeElement, 'keyup')
            .pipe(takeUntil(self._subrelease), debounceTime(150), distinctUntilChanged())
            .subscribe(function () {
            if (!self.StudentData) {
                return;
            }
            self.StudentData.filter = _this.filter.nativeElement.value;
        });
        // Wait for first non-null user object to load component
        self.userService.UserSubject.pipe(takeUntil(self._subrelease), first(function (item) { return item && !!item.AuthToken; })).subscribe(function (user) {
            self.User = user;
            self.SearchReady = true;
            // Set up constant monitoring of the user object, to catch AuthToken updates.
            self.userService.UserSubject.pipe(takeUntil(self._subrelease)).subscribe(function (_user) {
                self.User = _user;
            });
            // Load system values to continue.
            var curYearObs = self.appService.GetCurrentSchoolYear();
            combineLatest(curYearObs, function (curYear) {
                return {
                    CurrentYear: curYear,
                };
            })
                .pipe(takeUntil(self._subrelease))
                .subscribe(function (packet) {
                self.CurrentSchoolYear = packet.CurrentYear;
                // Prepare the rest of the component
                _this.SearchForm = _this.fb.group({
                    FirstName: [''],
                    LastName: [''],
                    StudentID: [''],
                    Grade: [''],
                }, {
                    validator: function (ctrl) {
                        if (!ctrl) {
                            return null;
                        }
                        var form = ctrl.value;
                        if (!form.FirstName && !form.LastName && !form.StudentID && !form.Grade) {
                            return { noneprovided: true };
                        }
                        if (!form.StudentID && !form.Grade) {
                            // Check to make sure we have at least 5 characters combined from the firstname and lastname fields
                            var fn = (form.FirstName || '').length;
                            var ln = (form.LastName || '').length;
                            if (fn + ln < 5) {
                                return { TooFewCharacters: true };
                            }
                        }
                        return null;
                    },
                });
                _this.StudentList = null;
                _this.StudentData = new DataTableSource([], self.paginator, self.sorter, self.SortStudents.bind(self), ['LastName', 'FirstName', 'StudentID', 'SchoolName']);
                _this.StudentSearchConducted = false;
            });
        });
    };
    // #region Cancel Handler Method
    StudentSearchDialogComponent.prototype.CancelHandler = function () {
        // User cancelled.
        this.dialogRef.close(null);
    };
    // #endregion
    // #region Handle User Key Method
    StudentSearchDialogComponent.prototype.HandleUserKey = function (key) {
        this.HandleStudentSearch();
    };
    // #endregion
    // #region Handle Student Search Method
    StudentSearchDialogComponent.prototype.HandleStudentSearch = function () {
        var self = this;
        var form = self.SearchForm.value;
        if (!form.FirstName && !form.LastName && !form.StudentID && !form.Grade) {
            self.splashService.SnackbarError('You must provide at least 1 search parameter in order to search.');
            return;
        }
        if (self.SearchForm.invalid) {
            return;
        }
        // Call the search for the user
        self.appService
            .SearchForStudent(self.User.AuthToken, self.User.CurrentRole, self.CurrentSchoolYear, null, form.StudentID, null, null, self.CurrentSchoolYear, form.Grade, form.FirstName, form.LastName)
            .subscribe(function (students) {
            // If small display format, hide the search form.
            if (self.SmallDisplay) {
                self.ShowSearch = false;
            }
            // Update into table with search results
            self.StudentList = students;
            if (students && students.length) {
                self.StudentData.Update(students);
                self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
                self.VisibleColumns = self.SmallDisplay ? ['SmallDisplay'] : self.VisibleHeaders.slice();
            }
            else {
                self.StudentData.Update([{}]);
                self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
                self.VisibleColumns = ['NoData'];
            }
            self.StudentSearchConducted = true;
        }, function (error) {
            var msg = null;
            if (error instanceof Response) {
                var body = error.json();
                msg = body.Message || (typeof body === 'string' ? body : 'An unknown error has occurred.');
            }
            else {
                var errorPacket = error.message || error;
                if (errorPacket != null && errorPacket !== '') {
                    errorPacket = JSON.parse(errorPacket);
                }
                msg =
                    errorPacket != null && errorPacket instanceof Object
                        ? errorPacket.ExceptionMessage || errorPacket.Message || error
                        : errorPacket || 'An unknown error has occurred.';
            }
            if (msg) {
                self.splashService.SnackbarError(msg);
            }
        });
    };
    // #endregion
    // #region OK Handler Method
    StudentSearchDialogComponent.prototype.OKHandler = function (student) {
        // User selected a search result. Pass back.
        this.dialogRef.close({
            ReportInfo: this.ReportInfo,
            StudentID: student && student.StudentID,
        });
    };
    // #endregion
    // #region Show Search Form Method
    StudentSearchDialogComponent.prototype.ShowSearchForm = function () {
        this.ShowSearch = true;
        this.StudentSearchConducted = false;
    };
    // #endregion
    // #region Sort Students Method
    StudentSearchDialogComponent.prototype.SortStudents = function (First, Second) {
        var self = this;
        var PropA;
        var PropB;
        switch (self.sorter.active) {
            case 'LastName':
                _a = [First.LastName, Second.LastName], PropA = _a[0], PropB = _a[1];
                break;
            case 'FirstName':
                _b = [First.FirstName, Second.FirstName], PropA = _b[0], PropB = _b[1];
                break;
            case 'StudentID':
                _c = [First.StudentID, Second.StudentID], PropA = _c[0], PropB = _c[1];
                break;
            case 'School':
                _d = [First.SchoolName, Second.SchoolName], PropA = _d[0], PropB = _d[1];
                break;
            case 'Grade':
                _e = [First.GradeLevel, Second.GradeLevel], PropA = _e[0], PropB = _e[1];
                break;
        }
        var ValueA = PropA != null && PropA !== '' ? (isNaN(+PropA) ? PropA : +PropA) : PropA;
        var ValueB = PropB != null && PropB !== '' ? (isNaN(+PropB) ? PropB : +PropB) : PropB;
        return (ValueA < ValueB ? -1 : 1) * (self.sorter.direction === 'asc' ? 1 : -1);
        var _a, _b, _c, _d, _e;
    };
    return StudentSearchDialogComponent;
}());
export { StudentSearchDialogComponent };
// #region Custom Classes
// #region Student Search Dialog Options Class
var BaseStudentSearchDialogOptions = /** @class */ (function () {
    function BaseStudentSearchDialogOptions() {
    }
    return BaseStudentSearchDialogOptions;
}());
export { BaseStudentSearchDialogOptions };
// #endregion
// #endregion



// WEBPACK FOOTER //
// ./src/services/dialogs/studentsearch/studentsearch.dialogcomponent.ts.pre-build-optimizer.js